(function () {
  function getSettings() {
    var el = document.getElementById('sale-badge-settings');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSaleUrls() {
    var urls = new Set();
    document.querySelectorAll('script[data-rubik-swatch-product-id]').forEach(function (script) {
      try {
        var data = JSON.parse(script.textContent);
        (data.groups || []).forEach(function (group) {
          (group.swatches || []).forEach(function (swatch) {
            if (swatch.productCompareAtPrice) urls.add(swatch.productUrl);
          });
        });
      } catch (e) {
        // ignore malformed swatch-data blocks
      }
    });
    return urls;
  }

  function buildBadge(settings) {
    var badge = document.createElement('div');
    badge.className = 'theme-sale-badge-swatch';
    badge.textContent = settings.text || 'Sale';
    badge.setAttribute(
      'style',
      [
        'position:absolute',
        'top:-6px',
        'right:-6px',
        'z-index:3',
        'padding:2px 6px',
        'border-radius:3px',
        'background:' + (settings.bg || '#000000'),
        'color:' + (settings.color || '#ffffff'),
        'font-size:8px',
        'font-weight:700',
        'text-transform:uppercase',
        'letter-spacing:.03em',
        'line-height:1.4',
        'pointer-events:none',
        'white-space:nowrap',
        'box-shadow:0 1px 3px rgba(0,0,0,.3)',
      ].join(';')
    );
    return badge;
  }

  function applyBadges(settings, saleUrls) {
    if (!saleUrls.size) return;
    document.querySelectorAll('rubik-combined-listings').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root) return;
      root.querySelectorAll('a.rcl__swatch[href]').forEach(function (swatch) {
        if (!saleUrls.has(swatch.getAttribute('href'))) return;
        if (swatch.querySelector('.theme-sale-badge-swatch')) return;
        // Anchor the badge to the swatch link itself (not the rounded/clipped
        // media box) and force overflow:visible so part of it can hang
        // outside the thumbnail edge, matching the reference design.
        if (getComputedStyle(swatch).position === 'static') {
          swatch.style.position = 'relative';
        }
        swatch.style.overflow = 'visible';
        var media = swatch.querySelector('.rcl__swatch-media');
        if (media) media.style.overflow = 'visible';
        swatch.appendChild(buildBadge(settings));
      });
    });
  }

  function init() {
    var settings = getSettings();
    if (!settings || !settings.enabled) return;
    var saleUrls = getSaleUrls();
    if (!saleUrls.size) return;

    var attempts = 0;
    var maxAttempts = 40; // poll for ~20s while the Rubik web component boots and renders
    var interval = setInterval(function () {
      applyBadges(settings, saleUrls);
      attempts += 1;
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
